// Customizable Area Start
import React from "react";
import AutomationController from "./AutomationController.web";
import {
  Card,
  Container,
  Grid,
  Typography,
  Box,
  Modal,
  Button,
  IconButton,
  TextField,
  Switch,
  styled
} from "@material-ui/core";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import { stepImageFirst, CloseIcon, EverybrandIcon, BinIcon } from "./assets";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import { Formik, Form } from "formik";
import * as yup from "yup";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { Link } from "react-router-dom";
import SimpleMessageVariablesDropdown from "../../comments/src/SimpleMessageVariablesDropdown.web";


const form_schema = yup.object().shape({
  subject: yup.string().required("Subject is required"),
  content: yup.string().required("Content is required"),
});

export class AutomationTemplates extends AutomationController {
  constructor(props:any) {
    super(props);
    this.updateSeemore = this.updateSeemore.bind(this);
  }

  // NEW: centralized save handler that ensures component state is updated after backend save
  handleTemplateSave = async (values: any) => {
    try {
      // Call the existing controller method which likely updates backend
      // Wrap in Promise.resolve so both sync/async implementations are handled
      await Promise.resolve(this.onUpDateTemplate(values));

      // After successful save, update local component state so reopened modal shows updated data
      const current = this.state.selectedTemplate || {};
      const updatedTemplate = {
        ...current,
        attributes: {
          ...current.attributes,
          name: values.subject,
          // save message_template as an object if backend expects object structure
          message_template: values.content,
        }
      };

      // Update lists that may be used when modal opens (defaultautomations or userautomtions)
      if (this.state.isdefaultAutomation) {
        const updatedDefaults = (this.state.defaultautomations || []).map((t: any) =>
          t.id === updatedTemplate.id ? { ...t, attributes: { ...t.attributes, name: values.subject, message_template: values.content } } : t
        );
        this.setState({
          selectedTemplate: updatedTemplate,
          defaultautomations: updatedDefaults,
          isEditMode: false,
        });
      } else {
        const updatedUsers = (this.state.userautomtions || []).map((t: any) =>
          t.id === updatedTemplate.id ? { ...t, attributes: { ...t.attributes, name: values.subject, message_template: values.content } } : t
        );
        this.setState({
          selectedTemplate: updatedTemplate,
          userautomtions: updatedUsers,
          isEditMode: false,
        });
      }

      // Show success alert if your controller expects it elsewhere
      this.setState({ showAlert: true, alertMsg: "Saved successfully" });

    } catch (err) {
      console.error("Save failed", err);
      this.setState({ showAlert: true, alertMsg: "Save failed" });
    }
  }
  setTemplatePage = (page: number) => {
    this.setState({ currentTemplatePage: page });
  }
  
  nextTemplatePage = () => {
    const totalPages = Math.ceil(this.state.defaultautomations.length / 9);
    if (this.state.currentTemplatePage < totalPages - 1) {
      this.setTemplatePage(this.state.currentTemplatePage + 1);
    }
  }
  
  prevTemplatePage = () => {
    if (this.state.currentTemplatePage > 0) {
      this.setTemplatePage(this.state.currentTemplatePage - 1);
    }
  }
  
  handleCreateNewClick = () => {
    this.setState({ isCreateModalOpen: true, newTemplateTitle: "", newTemplateMessage: "" });
  }
  
  handleCloseCreateModal = () => {
    this.setState({ isCreateModalOpen: false, newTemplateTitle: "", newTemplateMessage: "" });
  }
  
  handleSaveNewTemplate = () => {
    if (!this.state.newTemplateTitle.trim()) {
      alert("Template title is required");
      return;
    }
    if (!this.state.newTemplateMessage.trim()) {
      alert("Template message is required");
      return;
    }
    this.createAutomationTemplate(this.state.newTemplateTitle, this.state.newTemplateMessage);
  }
  render() {
    const { classes }: any = this.props;
    const endPoint = window.location.pathname;
    const defaultAutomationShow = this.state.defaultautomations.slice(0,this.state.displayItem);
    const htmlToPlainText = (html:any) => {
      if (!html) return "";
      return html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n\n")
        .replace(/<[^>]+>/g, "")
        .trim();
    };
    
    return (
      <Container className={classes.automationsContainer}>
        <Snackbar
          open={this.state.showAlert}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            data-test-id="webUpdateAlert"
            elevation={6}
            variant="filled"
            severity={"success"}
          >
            {this.state.alertMsg}
          </MuiAlert>
        </Snackbar>
        <Box className={classes.everyBrandBox}>
          <Typography
            data-test-id="autoHeading"
            className={classes.autoHeading}
          >
            Tap. Send. That's Brando!
          </Typography>
          {/* <img src={EverybrandIcon} alt="" /> */}
        </Box>

        <Typography className={classes.autoPara}>
        Brando is cheating. But like... in a good way. All your messages? Prepped. Ready. Just waiting for you to tap send. No typing. No stress. No "what do I even say?" It's fast. It's flawless. It's a little unfair, and we're fine with that.
        </Typography>
        <Typography className={classes.autoSubPara}
        style={{ marginBottom:"20px" }}>
        Templates
        </Typography>
        
        <Box className={classes.templatesSection}>
          {this.state.currentTemplatePage > 0 && (
            <IconButton 
              className={`${classes.navArrow} ${classes.navArrowLeft}`} 
              onClick={this.prevTemplatePage}
            >
              &#8249;
            </IconButton>
          )}
          
          <Box className={classes.templatesGrid}>
            {this.state.defaultautomations
              .slice(this.state.currentTemplatePage * 9, (this.state.currentTemplatePage + 1) * 9)
              .map((item: any, index: number) => (
              <Card
                key={item.id}
                className={classes.templateCard}
                onClick={() => {
                  this.openModal(item);
                  this.setAutomation(true);
                }}
                data-test-id="automationsCard"
              >
                <Box className={classes.cardIconBox}>
                  <img
                    src={stepImageFirst}
                    alt="template-icon"
                    className={classes.cardIcon}
                  />
                </Box>
                <Typography className={classes.cardText}>
                  {item.attributes.name}
                </Typography>
              </Card>
            ))}
          </Box>
          
          {Math.ceil(this.state.defaultautomations.length / 9) > this.state.currentTemplatePage + 1 && (
            <IconButton 
              className={`${classes.navArrow} ${classes.navArrowRight}`} 
              onClick={this.nextTemplatePage}
            >
              &#8250;
            </IconButton>
          )}
          
          <Box className={classes.paginationDots}>
            {Array.from({ length: Math.ceil(this.state.defaultautomations.length / 9) }).map((_, index) => (
              <Box 
                key={index} 
                className={index === this.state.currentTemplatePage ? classes.dotActive : classes.dot}
              ></Box>
            ))}
          </Box>
          
          <Box className={classes.createNewButtonBox}>
            <Button 
              variant="contained" 
              className={classes.createNewButton}
              onClick={this.handleCreateNewClick}
            >
              Create New
            </Button>
          </Box>
        </Box>
        <Grid container className={classes.mainGridBox}>
          {this.state.userautomtions.map((item: any) => (
            <Grid
              item
              md={6}
              lg={6}
              key={item.id}
              data-test-id="automationsMainGrid"
            >
              <Card
                className={classes.autoCards}
                
                data-test-id="automationsCard"
              >
                <Box className={classes.autosmileBox} 
                  display="flex"
                  justifyContent="space-between">
                  <img
                    src={stepImageFirst}
                    alt="simeimag"
                    style={{ height: "56px", width: "56px" }}
                    onClick={(event) => {
                      this.openModal(item);
                      this.setAutomation(false);
                    }}
                    data-test-id='userautomation'
                  />
                  <Box display="flex">
                  <AntSwitch defaultChecked= {item.attributes.is_active} inputProps={{ 'aria-label': 'ant design' }}
                    onClick={this.updateAutomationActive.bind(this,item.id,!(item?.attributes?.is_active))}                                      
                     />
                  <Box marginLeft="12px">
                  {item.attributes.is_active ? "On" : "Off"}
                  </Box>
                  </Box>
                 
                </Box>
                <Typography className={classes.autoPara}
                  data-test-id='userautomation'
                  onClick={(event) => {
                    this.openModal(item);
                    this.setAutomation(false);
                  }}>
                  {item.attributes.name}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Modal
          open={this.state.isModalOpen}
          onClose={this.handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          data-test-id="templateEditModal"
        >
          {this.state.isModalOpen && this.state.selectedTemplate && (() => {
            const template = this.state.selectedTemplate;
            const messageTemplate = template?.attributes?.message_template;
            
            // If message_template exists, use its content, otherwise show "Message"
            const subject = messageTemplate?.subject || template?.attributes?.name || "";
            // Handle both string (HTML) and object formats for message_template
            let content = "";
            if (messageTemplate !== undefined && messageTemplate !== null) {
              if (typeof messageTemplate === 'string') {
                // If it's a string (HTML), convert to plain text
                content = htmlToPlainText(messageTemplate);
              } else if (messageTemplate.content !== undefined && messageTemplate.content !== null) {
                // If it's an object with content property
                content = messageTemplate.content;
              }
            }
            // Default to empty string if no content found (allows user to clear field)
            if (!content) {
              content = "";
            }
                        
            return (
            <Box className={classes.modalBox}>
            <Formik
              data-test-id="templateEditForm"
              key={`template-${template?.id || 'form'}-${this.state.modalKey}`}
              enableReinitialize={true} // ALWAYS reinitialize so that updated state shows when modal reopens
              initialValues={{
                subject: subject,
                content: content,
              }}
              validationSchema={form_schema}
              onSubmit={(values) => {
                if (this.state.isdefaultAutomation && this.state.isEditMode) {
                  // Save changes for default automation
                  this.onUpDateTemplate(values);
                  this.toggleEditMode();
                } else if (!this.state.isdefaultAutomation) {
                  // Save for user automation
                  this.onUpDateTemplate(values);
                }
              }}
            >
              {({ errors, handleChange, handleBlur, values, handleSubmit }) => (
                <Form>
                  <Typography className={classes.modalHeading}>
                    {this.state.isdefaultAutomation ? "Everybrand Templates" : "Set up your automation"}
                  </Typography>
                  <IconButton
                    onClick={this.handleClose}
                    className={classes.crossIcon}
                    data-test-id="iconCrossButton"
                  >
                    <img src={CloseIcon} alt="" />
                  </IconButton>
                  <Box sx={{ marginTop: "20px" }}>
                    <Typography className={classes.inputName}>
                      {
                        this.state.isdefaultAutomation && "Template Title" || "When this happens:"
                      }
                    </Typography>
                    <TextField
                      className={classes.inputField}
                      data-test-id="subject"
                      variant="outlined"
                      label={this.state.isdefaultAutomation ? "Use a title that describes when to use this template" : "A contact form lead is received"}
                      value={values.subject}
                      onChange={handleChange("subject")}
                      error={Boolean(errors.subject)}
                      helperText={errors.subject}
                      onBlur={handleBlur("subject")}
                      InputProps={{
                        readOnly: this.state.isdefaultAutomation && !this.state.isEditMode
                      }}
                    />
                    <Typography className={classes.inputName}>
                      {
                        this.state.isdefaultAutomation && "Template Message" || " Send This Message:"
                      }

                    </Typography>
                    <Box className={classes.messageInputContainer}>
                      <Box className={classes.textFieldWrapper}>
                      {/* <TextField
                        className={classes.inputField}
                        data-test-id="content"
                        variant="outlined"
                        label="Message"
                        multiline
                        rows={8}
                        value={values.content}
                        onChange={(e) => handleChange("content")(e)}
                        error={Boolean(errors.content)}
                        helperText={errors.content}
                        onBlur={handleBlur("content")}
                        InputProps={{
                          readOnly: this.state.isdefaultAutomation && !this.state.isEditMode
                        }}
                        disabled={this.state.isdefaultAutomation && !this.state.isEditMode}
                      /> */}
                            <TextField
                              className={classes.inputField}
                              data-test-id="content"
                              variant="outlined"
                              label="Message"
                              multiline
                              rows={8}
                              value={values.content || ""}
                              onChange={(e) => handleChange("content")(e)}
                              error={Boolean(errors.content)}
                              helperText={errors.content}
                              onBlur={handleBlur("content")}
                              InputProps={{
                                readOnly: this.state.isdefaultAutomation && !this.state.isEditMode
                              }}
                              disabled={this.state.isdefaultAutomation && !this.state.isEditMode}
                            />

                        {((this.state.isdefaultAutomation && this.state.isEditMode) || !this.state.isdefaultAutomation) && (
                          <Box className={classes.variableButtonContainer}   style={{
                            bottom: values.content.trim() ? 8 : 30, // change position dynamically
                          }}>
                            <SimpleMessageVariablesDropdown
                              onVariableSelect={(variable: string) => {
                                const currentContent = values.content || "";
                                const newContent = currentContent + variable;
                                handleChange("content")({ target: { value: newContent } } as any);
                              }}
                              placeholder=":A:"
                              disabled={this.state.isdefaultAutomation && !this.state.isEditMode}
                            />
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  <Box className={classes.btnBox}>
                    {
                      this.state.isdefaultAutomation && <>
<Button
  variant="contained"
  className={classes.useTemplateBtn}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Get content from form values, with fallback to template's message_template content
    let contentToStore = values.content;
    
    // If form content is empty or just "Message", try to get it from the template
    if (!contentToStore || contentToStore === "Message" || contentToStore.trim() === "") {
      const messageTemplate = template?.attributes?.message_template;
      if (messageTemplate?.content) {
        contentToStore = messageTemplate.content;
      } else if (typeof messageTemplate === 'string') {
        contentToStore = messageTemplate;
      }
    }
    // Store template data in localStorage for prefill
    const templateData = {
      subject: values.subject || template?.attributes?.name || "",
      content: contentToStore || ""
    };
    localStorage.setItem('automationTemplate', JSON.stringify(templateData));
    
    // Verify it was stored
    const stored = localStorage.getItem('automationTemplate');
    
    // Close modal when navigating
    this.handleClose();
    // Navigate to messages page with new-chat query parameter
    // Use setTimeout to ensure modal closes before navigation
    setTimeout(() => {
      window.location.href = '/messages?new-chat=true';
    }, 100);
  }}
>
  Use
</Button>


      <Button
        data-test-id="continueBtn"
        type={this.state.isEditMode ? "submit" : "button"}
        variant="contained"
        className={classes.useTemplateBtn}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.state.isEditMode) {
            // Save button: Submit the form (this will call onSubmit which saves the data)
            handleSubmit();
          } else {
            // Edit button: Just enable edit mode, don't save anything
            this.toggleEditMode();
          }
        }}
        
      >
        {this.state.isEditMode ? "Save" : "Edit"}
      </Button>

      <Button
        style={{
          backgroundColor: "transparent",
          minWidth: "40px",
          boxShadow: "none",
        }}
        onClick={() => this.deleteAutomationTemplate(this.state.selectedTemplate?.id)}
      >
        <img src={BinIcon} style={{width:'25px', height:"25px"}} />
      </Button>
                        
                       
                      </> ||
                       <>
                        <Button
                          data-test-id="continueBtn"
                          type="submit"
                          variant="contained"
                          className={classes.continueBtn}
                        >
                          Save
                        </Button>
                        <IconButton>
                          <MenuOpenIcon />
                        </IconButton>
                      </>
                    }
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
            );
          })()}
        </Modal>

        {/* Create New Modal */}
        <Modal
          open={this.state.isCreateModalOpen || false}
          onClose={this.handleCloseCreateModal}
          aria-labelledby="create-new-brando-modal"
        >
          <Box className={classes.createModalBox}>
            <IconButton
              onClick={this.handleCloseCreateModal}
              className={classes.modalCloseButton}
            >
              <img src={CloseIcon} alt="Close" />
            </IconButton>
            
            <Typography className={classes.createModalHeading}>
              Create New Brando
            </Typography>
            
            <Box className={classes.createModalContent}>
              <Typography className={classes.inputLabel}>
                Template Title
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter template title"
                value={this.state.newTemplateTitle || ""}
                onChange={(e) => this.setState({ newTemplateTitle: e.target.value })}
                className={classes.createModalInput}
              />
              
              <Typography className={classes.inputLabel}>
                Message
              </Typography>
              <Box className={classes.messageInputContainer}>
              <TextField
                fullWidth
                multiline
                rows={6}
                variant="outlined"
                placeholder="Enter your message"
                value={this.state.newTemplateMessage || ""}
                onChange={(e) => this.setState({ newTemplateMessage: e.target.value })}
                className={classes.createModalInput}
                InputProps={{
                  style: { height: 'auto' }
                }}
                inputProps={{
                  style: { height: 'auto', minHeight: 'auto' }
                }}
              />
                <Box className={classes.variableButtonContainer}   style={{
    bottom: this.state.newTemplateMessage.trim() ? 8 : 30, // change position dynamically
  }}>
                  <SimpleMessageVariablesDropdown
                    onVariableSelect={(variable: string) => {
                      const currentMessage = this.state.newTemplateMessage || "";
                      this.setState({ newTemplateMessage: currentMessage + variable });
                    }}
                    placeholder=":A:"
                    disabled={false}
                  />
                </Box>
              </Box>
            </Box>
            
            <Box className={classes.createModalFooter}>
              <Button
                variant="contained"
                className={classes.modalSaveButton}
                onClick={this.handleSaveNewTemplate}
              >
                Save
              </Button>
              <IconButton className={classes.modalMenuIcon}>
                <MenuOpenIcon />
              </IconButton>
            </Box>
          </Box>
        </Modal>
      </Container>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    everyBrandBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    mainGridBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    },
    btnBox: {
      margin: "10px 0",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    continueBtn: {
      backgroundColor: "#FFC629",
      borderRadius: "8px",
      textTransform: "none",
      color: "#0F172A",
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "24px",
      padding: "10px 50px",
    },
    SaveChangesBtn: {
      backgroundColor: "#0F172A",
      borderRadius: "8px",
      textTransform: "none",
      color: "#FFFFFF",
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "24px",
      padding: "10px 35px",
    },
    useTemplateBtn: {
      backgroundColor: "#FFC629",
      borderRadius: "8px",
      textTransform: "none",
      color: "#0F172A",
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "24px",
      padding: "10px 35px",
      width:'40%'
    },
    inputField: {
      width: "100%",
      margin: "10px 0",
    },
    messageInputContainer: {
      position: "relative",
      width: "100%",
    },
    textFieldWrapper: {
      position: "relative",
      width: "100%",
      "& .MuiTextField-root": {
        width: "100%",
      },
      "& .MuiOutlinedInput-root": {
        position: "relative",
      },
      "& .MuiInputBase-input": {
        paddingRight: "50px !important",
        paddingBottom: "32px !important", // prevents overlap
      },
      "& textarea": {
        paddingRight: "50px !important",
        paddingBottom: "32px !important", // same for multiline
      },
    },
    variableButtonContainer: {
      position: "absolute",
      right: "12px",
      zIndex: 2,
      pointerEvents: "auto",
      display: "flex",
      alignItems: "center",
      transition: "bottom 0.2s ease-in-out", // smooth movement
    },
    
    inputName: {
      color: "#334155",
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "22px",
    },
    crossIcon: {
      top: "10px",
      right: "10px",
      position: "absolute",
    },
    modalHeading: {
      color: "#000",
      textAlign: "center",
      fontSize: "24px",
      fontWeight: 700,
      lineHeight: "32px",
      letterSpacing: "-0.12px",
    },
    modalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "32px 48px 24px",
      width: "480px",
      borderRadius: "0px 0px 40px 0",
      top: "50%",
      transform: "translate(-50%, -50%)",
      left: "50%",
      [theme.breakpoints.down(480)]: {
        width: "96%"
      }
    },
    autoCards: {
      padding: "20px 30px",
      width: "90%",
      height: "187px",
      margin: "10px 0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      "&:hover": {
        cursor: "pointer",
        boxShadow: "",
      },
    },
    automationsContainer: {
      padding: "50px",
      [theme.breakpoints.down(950)]: {
        padding: "24px",
      }
    },
    autoHeading: {
      color: "#000",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "32px",
      letterSpacing: "-0.12px",
      marginBottom: "20px",
    },
    autoPara: {
      color: "#000",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "-0.12px",
      marginBottom: "25px",
    },
    autoSubPara: {
      color: "#000",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "32px",
      letterSpacing: "-0.12px",
    },
    seeMoreButtonContainer : {
      display:"flex",
      justifyContent:"end",
      marginTop:"17px"
    },
    seeMoreButton: {
      width: '233px',
      padding: '8px',
      borderRadius: '8px',
      backgroundColor: '#FFC629',
      textTransform: 'none',
      color: '#0F172A',
      fontFamily: 'Inter', 
      fontSize: '16px', 
      fontWeight: 700, 
      lineHeight: '24px', 
      textAlign: 'center', 
      cursor:"pointer"
    },
    templatesSection: {
      position: "relative",
      // backgroundColor: "#E5E7EB",
      borderRadius: "12px",
      padding: "24px",
      marginBottom: "40px",
    },
    templatesGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "16px",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    },
    templateCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      minHeight: "180px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      "&:hover": {
        backgroundColor: "#E5E7EB",
        transform: "translateY(-2px)",
        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
      },
    },
    cardIconBox: {
      marginBottom: "12px",
      display: "flex",
      alignSelf:"flex-start",
      marginLeft: "20px",
    },
    cardIcon: {
      width: "56px",
      height: "56px",
    },
    cardText: {
      color: "#000",
      fontSize: "14px",
      fontWeight: 400,
      textAlign: "center",
      lineHeight: "20px",
    },
    navArrow: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: "#374151",
      color: "#fff",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      "&:hover": {
        backgroundColor: "#4B5563",
      },
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    navArrowLeft: {
      left: "-32px",
    },
    navArrowRight: {
      right: "-32px",
    },
    paginationDots: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      marginTop: "20px",
    },
    dot: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#000",
      opacity: 0.4,
    },
    dotActive: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#000",
      opacity: 1,
    },
    createNewButtonBox: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "20px",
    },
    createNewButton: {
      backgroundColor: "#FFC629",
      color: "#0F172A",
      fontWeight: 700,
      textTransform: "none",
      borderRadius: "8px",
      padding: "10px 24px",
      "&:hover": {
        backgroundColor: "#FFD84D",
      },
    },
    createModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "32px 40px",
      width: "480px",
      borderRadius: "12px",
      top: "50%",
      transform: "translate(-50%, -50%)",
      left: "50%",
      outline: "none",
      [theme.breakpoints.down(480)]: {
        width: "95%",
        padding: "24px",
      }
    },
    modalCloseButton: {
      position: "absolute",
      top: "16px",
      right: "16px",
      padding: "4px",
    },
    createModalHeading: {
      fontSize: "24px",
      fontWeight: 700,
      color: "#000",
      marginBottom: "24px",
      textAlign: "center",
    },
    createModalContent: {
      marginBottom: "24px",
    },
    inputLabel: {
      fontSize: "14px",
      fontWeight: 700,
      color: "#334155",
      marginBottom: "8px",
      marginTop: "16px",
      "&:first-of-type": {
        marginTop: 0,
      },
    },
    createModalInput: {
      marginBottom: "8px",
    },
    createModalFooter: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    modalSaveButton: {
      backgroundColor: "#FFC629",
      color: "#0F172A",
      fontWeight: 700,
      textTransform: "none",
      borderRadius: "8px",
      padding: "12px 32px",
      "&:hover": {
        backgroundColor: "#FFD84D",
      },
    },
    modalMenuIcon: {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    },
});
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 32,
    height: 17,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2.9,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#FFC629',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:'#E2E8F0',
      boxSizing: 'border-box',
    },
}));
  
export default withStyles(styles)(AutomationTemplates);
// Customizable Area End
